import { render, staticRenderFns } from "./MergerAcquisitionsCreateView.vue?vue&type=template&id=f0f87cd4&"
import script from "./MergerAcquisitionsCreateView.vue?vue&type=script&lang=ts&"
export * from "./MergerAcquisitionsCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports